export enum InvoiceDashboardViews {
    TissuesReady = "tissuesReady",
    TissuesNotReady = "tissuesNotReady",
    InvoicesReady = "invoicesReady",
    InvoicesFlagged = "invoicesFlagged",
}
